<template>
<div class="page">
  <p style="text-align: center; margin-top: 0px; margin-bottom: 0px;">
      <span style="font-weight:bold;font-size:22pt;font-family:宋体, 宋体, undefined, 宋体">用户注销协议</span>
  </p>
  <p style="text-indent: 32px; margin-top: 0px; margin-bottom: 0px; line-height: 150%;">
      <span style="font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">在您注销您的卓闻填呗账号之前，请充分阅读、理解并同意下列事项</span><span style="font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">:</span>
  </p>
  <p style="text-indent: 32px; margin-top: 0px; margin-bottom: 0px; line-height: 150%;">
      <span style="font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">在此善意地提醒您，您注销本填呗账号的行为，将导致我们终止对您提供本服务，也会给您的售后维权带来诸多不便。注销成功后，我们将删除您的个人信息，使其保持不可被检索、访问的状态，或对其进行匿名化处理。您知晓并理解，依据相关法律法规规定或双方约定，我们仅会在实现法律规定或双方约定目的所必须的最短时间内留存您的相关个人信息。</span>
  </p>
  <p style="margin-top: 0px; margin-bottom: 0px; line-height: 150%;">
      <span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">1、如果您仍执意注销本填呗账号，您的填呗账号需同时</span><span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">满足以下条件</span><span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">:</span>
  </p>
  <p style="margin-top: 0px; margin-bottom: 0px; line-height: 150%;">
      <span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">(1)&nbsp;账号内无资产、无欠款;</span>
  </p>
  <p style="margin-top: 0px; margin-bottom: 0px; line-height: 150%;">
      <span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">(2)&nbsp;账号内无未完成的订单、已提供服务但未支付的订</span><span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">单</span><span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">;</span>
  </p>
  <p style="margin-top: 0px; margin-bottom: 0px; line-height: 150%;">
      <span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">(3)&nbsp;账号无任何纠纷，包括投诉举报或被投诉举报;</span>
  </p>
  <p style="margin-top: 0px; margin-bottom: 0px; line-height: 150%;">
      <span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">(4)&nbsp;账号可正常使用中且无任何被限制的记录;</span>
  </p>
  <p style="margin-top: 0px; margin-bottom: 0px; line-height: 150%;">
      <span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">(5)&nbsp;账号对应的</span><span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">余额已清空；</span>
  </p>
  <p style="margin-top: 0px; margin-bottom: 0px; line-height: 150%;">
      <span style="font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">2、在填呗账号注销期间，如果您的填呗账号涉及争议纠</span><span style="font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查等，我们有权自行终止填呗账号的注销而无需另行得到您的同意。</span>
  </p>
  <p style="margin-top: 0px; margin-bottom: 0px; line-height: 150%;">
      <span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">3、填呗账号-旦被注销将不可恢复，请您在操作之前自</span><span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">行备份填呗账号相关的所有信息和数据。注销填呗账号，您将无法再使用填呗账号，也将无法找回您填呗账号内所有历史记录信息</span><span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">(即使您使用相同的手机号码再次</span><span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">注册并使用</span><span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">)，包括但不限于:</span>
  </p>
  <p style="margin-top: 0px; margin-bottom: 0px; line-height: 150%;">
      <span style="font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">(1)&nbsp;您将无法登录、使用填呗账号;</span>
  </p>
  <p style="margin-top: 0px; margin-bottom: 0px; line-height: 150%;">
      <span style="font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">(2)&nbsp;填呗账号的个人资料和历史信息(包括但不限于用</span><span style="font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">户名、昵称、头像、交易</span><span style="font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">记录等)都将无法找回;</span>
  </p>
  <p style="margin-top: 0px; margin-bottom: 0px; line-height: 150%;">
      <span style="font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">(3)&nbsp;您通过填呗账号进行登录的卓闻数据旗下各网站/App (包括但不限于填呗APP、卓闻全球品牌数据库等)所有记录将无法找回。您将无法再登录、使用前述服务，您曾获得的余额、积分等视为您自行放弃，将无法继续使用。您理解并同意，填呗无法协助您重新恢复前述服务</span>
  </p>
  <p style="margin-top: 0px; margin-bottom: 0px; line-height: 150%;">
      <span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">4、注销本填呗账号并不代表本填呗账号注销前的账号行</span><span style="font-weight:bold;font-size:12pt;font-family:宋体, 宋体, undefined, 宋体">为和相关责任得到豁免或减轻。</span>
  </p>
</div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  components: {
  },
  created () {
    
  },
  mounted () {
  },
  computed:{
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
.page{
  width: 100%;
  height: 100vh;
  background-color: #f7f7f7;
  border-top: 2px solid #f5f5f5;
  padding: 46px 24px;
  box-sizing: border-box;
  font-size: 28px;
  line-height: 52px;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/views/other/userCancellation.vue